module.exports = __webpack_public_path__ + "img/ecdc-logo.ace97052.svg";